module.exports = __webpack_public_path__ + "img/service-tabs.bfd3e76e.png";